import React from 'react';
import { Box } from 'theme-ui';
import ImgLoader from '~/components/Generic/ImgLoader';
import MuxVideoPlayer from '~/components/Generic/MuxPlayer';

type Props = {
  image: Queries.ActivityExpertFragment['image'];
  video: Queries.ActivityExpertFragment['video'];
  accentColor?: string;
};

const PrimaryExpertMedia = ({ image, video, accentColor }: Props) => {
  return (
    <Box
      sx={{
        gridArea: 'image',
        aspectRatio: ['1/1', '144/95', '1/1'],
        width: '100%',
      }}
    >
      <MainMedia image={image} video={video} accentColor={accentColor} />
    </Box>
  );
};

export default PrimaryExpertMedia;

const MainMedia = ({ image, video, accentColor }: Props) => {
  if (image) {
    return <ImgLoader image={image} />;
  }
  if (video) {
    return (
      <MuxVideoPlayer
        muxVideo={video}
        autoPlay={false}
        loop={false}
        accentColor={accentColor}
        forwardSx={{
          '--seek-backward-button': 'none',
          '--seek-forward-button': 'none',
          '--fullscreen-button': 'none',
          '--airplay-button': 'none',
          '--pip-button': 'none',
          '--playback-rate-button': 'none',
        }}
      />
    );
  }
  return null;
};
